import { useState } from 'react';

import Header from '@/components/Header';
import SidebarContent from '@/components/SidebarContent';
import { cn } from '@/lib/utils';

import OverlayProvider from './OverlayProvider';

const RootLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div
      className="flex flex-col min-h-screen bg-background pt-14"
      // Single source of truth for the desktop sidebar width. The <Toolbar> is
      // position:fixed (so it can sit above the page with a blur), which means
      // it can't inherit <main>'s margin — it reads this instead.
      style={{ '--sidebar-width': sidebarCollapsed ? '4rem' : '16rem' }}
    >
      <Header
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        sidebarCollapsed={sidebarCollapsed}
        toggleSidebar={toggleSidebar}
      />

      <div className="flex grow">
        <aside
          className={cn(
            sidebarCollapsed ? 'w-16' : 'w-64',
            'hidden md:block transition-[width] duration-200 ease-in-out border-r bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
            'md:fixed md:bottom-0 md:top-14'
          )}
        >
          <SidebarContent
            setMobileMenuOpen={setMobileMenuOpen}
            sidebarCollapsed={sidebarCollapsed}
          />
        </aside>

        <main
          className={cn(
            'flex-1 overflow-auto transition-[margin] duration-200 ease-in-out',
            sidebarCollapsed ? 'md:ml-16' : 'md:ml-64'
          )}
        >
          <OverlayProvider>{children}</OverlayProvider>
        </main>
      </div>
    </div>
  );
};

export default RootLayout;
